module.exports = __webpack_public_path__ + "static/img/icon-5.63b959e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/layer3/en/role-4/icon-5.png
// module id = 5NpF
// module chunks = 0